<div class="modal-header border-bottom-0">
</div>
<div class="modal-body pb-5">
  <div class="container-fluid">
    <div class="row" [formGroup]="consentForm">
      <div class="col-12 col-md-6 form-group required">
        <div class="row pb-3 pb-md-2">
          <div class="col-12"><span
            class="control-label">{{'common.formFieldsLabels.firstName' | translate:{type: ''} }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-12 input-group">
            <input
              formControlName="firstName"
              class="form-control"
              mask="S*"
              type="text"
            >
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 form-group required">
        <div class="row pb-3 pb-md-2">
          <div class="col-12"><span
            class="control-label">{{'common.formFieldsLabels.phoneNumber' | translate:{type: ''} }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-12 input-group">
            <input
              [ngClass]="{'is-invalid': phoneNumber.invalid && (phoneNumber.dirty || phoneNumber.touched)}"
              [dropSpecialCharacters]= "false"
              formControlName="phoneNumber"
              class="form-control"
              mask="000-000-0000"
              placeholder="000-000-0000"
              type="text"
            >
            <div *ngIf="phoneNumber.touched && phoneNumber?.errors?.required" class="invalid-feedback">
              {{'common.formErrors.required' | translate}}</div>
            <div *ngIf="phoneNumber.touched && phoneNumber?.errors?.mask" class="invalid-feedback">
              {{'common.formErrors.format' | translate: {format: '000-000-0000'} }}</div>
          </div>
        </div>
      </div>
      <div class="col-12 form-group required">
        <div class="row pb-3 pb-md-2">
          <div class="col-12"><span
            class="control-label">{{'common.formFieldsLabels.email' | translate:{type: ''} }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-12 input-group">
            <input
              formControlName="email"
              class="form-control"
              type="email"
            >
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-12 text-center">
        <p>{{ translationPrefix +'disclaimer' | translate}}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <button (click)="submitSelection(true);" aria-label="Close" class="btn btn-success btn-lg w-100" type="button">
          <span aria-hidden="true">{{'common.formFieldsValues.defaultRadio.yes' | translate}}</span>
        </button>
      </div>
      <div class="col-6">
        <button (click)="submitSelection(false);" aria-label="Close" class="btn btn-outline-success btn-lg w-100" type="button">
          <span aria-hidden="true">{{'common.formFieldsValues.defaultRadio.no' | translate}}</span>
        </button>
      </div>
    </div>
  </div>
</div>
